import React from 'react';
import { AppProvider, useAppContext } from './context/AppContext';
import { createBrowserRouter, RouterProvider, Navigate, Outlet } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { darkTheme, lightTheme, GlobalStyle } from './theme';

// --- Page Imports ---
import LoginPage from './pages/LoginPage';
import CreatePage from './pages/CreatePage';
import TestPage from './pages/TestPage';
import EvolvePage from './pages/EvolvePage';
import LineagePage from './pages/LineagePage';
import GalleryPage from './pages/GalleryPage';
import AppLayout from './components/AppLayout';

// --- Protected Route ---
const ProtectedRoute = () => {
  const { currentUser } = useAppContext(); // Use new context
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

// --- App Router (Updated Evolve route) ---
const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <ProtectedRoute />,
    children: [
      { path: "/", element: <Navigate to="/create" replace /> },
      { path: "/create", element: <CreatePage /> },
      { path: "/test", element: <TestPage /> },
      { path: "/test/:genomeId", element: <TestPage /> },
      { path: "/evolve", element: <EvolvePage /> },
      { path: "/evolve/:genomeId", element: <EvolvePage /> }, // <-- Add detail route
      { path: "/lineage", element: <LineagePage /> },
      { path: "/gallery", element: <GalleryPage /> },
    ]
  }
]);

// Main App Component
const AppWithTheme = () => {
  const { themeMode } = useAppContext();
  return (
    <ThemeProvider theme={themeMode === 'dark' ? darkTheme : lightTheme}>
      <GlobalStyle />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

// Final App component wrapped in the Provider
function App() {
  return (
    <AppProvider>
      <AppWithTheme />
    </AppProvider>
  );
}

export default App;